import { CheckboxGroupField } from "@/components/ui/form/fields/check-box-field/check-box-group";

import { useWeekendSettings } from "./hooks/use-weekend-settings";
import { PriceInput } from "../_components/price-input";

export const StaticPriceWeekendSettings = () => {
	const {
		rawAvailableWeekend,
		onSetAvailableWeekend,
		weekendPriceFieldOptions,
		onSetWeekendPriceInput,
		capacityPeopleMaximum,
		weekendPrices,
		canAppendItem,
		appendItem,
		removeItem,
		onSetWeekendUpperNum,
	} = useWeekendSettings();

	return (
		<div className="space-y-6">
			<h5>休日価格にする曜日を設定してください</h5>
			<CheckboxGroupField
				value={rawAvailableWeekend}
				options={weekendPriceFieldOptions}
				handleCheckedChange={onSetAvailableWeekend}
				gridCols={2}
			/>
			<PriceInput
				prices={weekendPrices}
				appendItem={appendItem}
				capacityPeopleMaximum={capacityPeopleMaximum}
				canAppendItem={canAppendItem}
				removeItem={removeItem}
				onSetWeekendPriceInput={onSetWeekendPriceInput}
				onSetWeekendUpperNum={onSetWeekendUpperNum}
			/>
		</div>
	);
};
